export default __webpack_public_path__ + "static/media/6.a87c4d1c.gif";